/**
 * Uniform grid for O(1) neighbor queries (avoidance).
 */
export class NPCSpatialIndex {
  /** @param {number} cellSize */
  constructor(cellSize = 2.5) {
    this.cellSize = cellSize;
    /** @type {Map<string, import('./NPC.js').NPC[]>} */
    this._cells = new Map();
  }

  /** @param {import('./NPC.js').NPC[]} active */
  rebuild(active) {
    this._cells.clear();
    for (const npc of active) {
      if (!npc.active) continue;
      const key = this._key(npc.position.x, npc.position.z);
      if (!this._cells.has(key)) this._cells.set(key, []);
      this._cells.get(key).push(npc);
    }
  }

  /**
   * @param {number} x
   * @param {number} z
   * @param {number} radius
   * @returns {import('./NPC.js').NPC[]}
   */
  query(x, z, radius) {
    const cs = this.cellSize;
    const r = Math.ceil(radius / cs);
    const cx = Math.floor(x / cs);
    const cz = Math.floor(z / cs);
    /** @type {import('./NPC.js').NPC[]} */
    const out = [];
    for (let dz = -r; dz <= r; dz += 1) {
      for (let dx = -r; dx <= r; dx += 1) {
        const list = this._cells.get(`${cx + dx},${cz + dz}`);
        if (!list) continue;
        for (const npc of list) {
          out.push(npc);
        }
      }
    }
    return out;
  }

  _key(x, z) {
    const cs = this.cellSize;
    return `${Math.floor(x / cs)},${Math.floor(z / cs)}`;
  }
}
